import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d7fc98c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "g-card recipient" }
const _hoisted_2 = { class: "form-header" }
const _hoisted_3 = { class: "form-subtitle" }
const _hoisted_4 = {
  key: 0,
  class: "receiver-address receiver-info"
}
const _hoisted_5 = { class: "item" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = { class: "text" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "add-address-tips" }, " 添加地址 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Icon, { icon: "icon_fillinfor" }),
        _createTextVNode(" 收件人信息 "),
        (_ctx.form.address)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "change-address",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toSelectAddress && _ctx.toSelectAddress(...args)))
            }, " 修改地址 "))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.form.address)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Icon, {
              class: "icon",
              icon: "icon_user"
            }),
            _createElementVNode("text", _hoisted_6, _toDisplayString(_ctx.form.address.firstname), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Icon, {
              class: "icon",
              icon: "icon_phone"
            }),
            _createElementVNode("text", _hoisted_8, _toDisplayString(_ctx.form.address.mobile), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Icon, {
              class: "icon",
              icon: "icon_address"
            }),
            _createElementVNode("text", _hoisted_10, _toDisplayString(_ctx.getAddressDetail(_ctx.form.address)), 1)
          ]),
          (_ctx.countryInfo)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "country-icon",
                src: _ctx.countryInfo.icon
              }, null, 8, _hoisted_11))
            : _createCommentVNode("", true)
        ]))
      : (!_ctx.isLogin)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "unlogin",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navLogin && _ctx.navLogin(...args)))
          }, " 登录后查看 "))
        : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "empty-address",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toSelectAddress && _ctx.toSelectAddress(...args)))
          }, [
            _createTextVNode(" 当前无收货地址，点击这里 "),
            _hoisted_12
          ]))
  ]))
}